const request = {
    invalid_input: '輸入無效。{{details}}',
    general: '發生請求錯誤。',
    /** UNTRANSLATED */
    range_not_satisfiable: 'Range not satisfiable.',
    /** UNTRANSLATED */
    too_many_requests: 'Too many requests.',
};
export default Object.freeze(request);
